import { BRAND } from "../../type/EnumBrand";
import { IBrand } from "../../type/IBrand";

export const warmaudio: IBrand = {
  id: "warm-audio",
  name: BRAND.WARM_AUDIO,
  logo: "/logo/warm-logo.webp",
  website: "https://warmaudio.com/",
  description: `
Serious gear at an affordable price.
Warm Audio began when founder Bryce Young had a desire to help aspiring musicians & engineers gain access to fully professional recording equipment.  
Warm Audio manufactures classic analog recording gear that many musicians only dreamt of owning just a few years ago.  
  `
}